import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';
import type { FailureReason } from '@Application/Security/TokenJourney/FailureReason';

export type PasswordResetFailedAction = {
	type: 'PASSWORD_RESET_FAILED';
	payload: ExtractedMessages;
	reason: FailureReason;
	message: string;
};

export default (
	payload: ExtractedMessages,
	reason: FailureReason,
	message: string,
): PasswordResetFailedAction => ({
	type: 'PASSWORD_RESET_FAILED',
	payload,
	reason,
	message,
});
